import styled from 'styled-components'
import { COLORS } from 'utils'

import { IconStyles } from '../types'
import { Visibility } from '@mui/icons-material'

export const MagnifyingGlass = styled.div<IconStyles>`
  margin-top: ${({ marginTop }) => marginTop || '0'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  margin-left: ${({ marginLeft }) => marginLeft || '0'};
  margin-right: ${({ marginRight }) => marginRight || '0'};
  cursor: ${({ cursor }) => cursor || 'pointer'};
  color: ${({ colorIcon }) => colorIcon || COLORS.black};
  opacity: ${({ opacity }) => opacity || 1};
  display: flex;
  position: relative;

  &:hover .hover-text {
  visibility: visible;
  opacity: 1;
  transform: translateY(-0.5rem);
  }
`;

export const HoverText = styled.span`
  Visibility: hidden;
  opacity: 0;
  width: 7.5rem; /* Alterado para rem */
  background-color: #B6CFE6;
  color: #320F00;
  text-align: center;
  border-radius: 6px;
  padding: 0.3125rem 0.4125rem; /* Alterado para rem */
  position: absolute;
  z-index: 1;
  top: calc(100% + 0.9125rem); /* Ajustado para rem */
  left: 50%;
  transform: translateX(-50%);
  margin-left: -6.925rem; /* Alterado para rem */
  font-size: 0.875rem; /* Alterado para rem */
  transition: opacity 0.3s ease, transform 0.3s ease;

  &:after {
    content: "";
    position: absolute;
    top: -0.3125rem; /* Ajustado para rem */
    left: calc(50% + 2.4rem); /* Ajustado para rem */
    border-width: 0.3125rem; /* Ajustado para rem */
    border-style: solid;
    border-color: #000 transparent transparent transparent;
  }
`;


